import React from 'react'
import {
  StandardLocalWidget,
  any,
  async,
  fromJSX,
  nothing,
} from 'widgets-for-react'
import { DishHighlightLayout } from './dishHighlightLayout'
import { DishHighlightState } from './dishHighlightState'

export const dishHighlightWidget: StandardLocalWidget<DishHighlightState> = (
  dishHighlightState
) =>
  any([
    async(dishHighlightState),
    dishHighlightState.kind == 'unloaded'
      ? nothing()
      : fromJSX(() => (
          <DishHighlightLayout
            teaser={
              dishHighlightState.kind == 'loaded'
                ? dishHighlightState.value == null
                  ? 'empty'
                  : dishHighlightState.value
                : dishHighlightState.kind == 'loading'
                ? 'loading'
                : 'error'
            }
          />
        )),
  ])
